import dayjs from "dayjs";

export const convertNumberToTimestamp = (time: number): string => {
  return dayjs.unix(time).format("YY.MM.DD hh:mm A");
};
